<div class="d-flex align-items-center">
  <div
    class="{{ data?.statusOfCandidatOnMission | stausCandidatMissionColor }}"
    [matTooltip]="
      data?.statusOfCandidatOnMission ==
      statusOfCandidatOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT
        ? 'Vous recevrez une notification dés que l’agence effectuera le paiement.'
        : data?.statusOfCandidatOnMission ==
          statusOfCandidatOnMission.PAYMENT_DONE
        ? 'Paiement effectué'
        : data?.statusOfCandidatOnMission ==
          statusOfCandidatOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT
        ? 'Annulation demandée après la signature du contrat'
        : data?.statusOfCandidatOnMission ==
          statusOfCandidatOnMission.CANCELED_BY_CANDIDATE
        ? 'Mission annulée par vous'
        : ''
    "
  >
    {{ data?.statusOfCandidatOnMission | candidatMissionStatus }}
  </div>
  <svg-icon
    class="ms-2"
    (click)="goTo(data.id)"
    [matTooltip]="'Voir détails de la mission'"
    src="/assets/icons/export.svg"
  >
  </svg-icon>

  <svg-icon
    (click)="deleteMission(data.id)"
    *ngIf="
      data?.statusOfCandidatOnMission ==
        statusOfCandidatOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT ||
      data?.statusOfCandidatOnMission ==
        statusOfCandidatOnMission.CANCELED_BY_CANDIDATE ||
      data?.statusOfCandidatOnMission == statusOfCandidatOnMission.ACCEPTED ||
      data?.statusOfCandidatOnMission ==
        statusOfCandidatOnMission.CANCELED_BY_ESTABLISHMENT ||
      data?.statusOfCandidatOnMission ==
        statusOfCandidatOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION ||
      data?.statusOfCandidatOnMission == statusOfCandidatOnMission.REJECTED ||
      data?.statusOfCandidatOnMission == statusOfCandidatOnMission.RESERVED ||
      data?.statusOfCandidatOnMission ==
        statusOfCandidatOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
    "
    [matTooltip]="'Supprimer la mission'"
    src="/assets/icons/trash-red.svg"
  ></svg-icon>
  <svg-icon
    class="ms-2"
    *ngIf="
      data?.statusOfCandidatOnMission ==
      statusOfCandidatOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT
    "
    [matTooltip]="'Voir motif de refus'"
    (click)="voirDetails(data)"
    src="/assets/icons/eye-icon.svg"
  >
  </svg-icon>
  <svg-icon
    class="ms-2"
    *ngIf="
      data?.statusOfCandidatOnMission ==
      statusOfCandidatOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT
    "
    matTooltip="Evoyer un mail pour Contester le refus de validation de la mission"
    (click)="sendMail(data)"
    src="/assets/icons/send-mail.svg"
  >
  </svg-icon>
  <svg-icon
    class="ms-2"
    *ngIf="
      data?.statusOfCandidatOnMission == statusOfCandidatOnMission.PAYMENT_DONE
    "
    matTooltip="Voir détail de la payement"
    src="/assets/icons/dollar.svg"
  >
  </svg-icon>

  <!-- <svg-icon
    class="ms-2"
    (click)="openImputationDialog(data)"
    [matTooltip]="'Relevé d’heures'"
    src="/assets/icons/calender-check-primary.svg">
  </svg-icon> -->

</div>
